import { BlogEnum } from '@/types/translations/BlogEnum';
import { PrimaryButtonLink } from '../common/PrimaryButton';
import { Col, Container } from 'react-bootstrap';
import RelatedBlogs from '../blog/related_blogs';
import useTypedTranslation from '@/hooks/useTypedTranslation';

export const LatestArticles = () => {
  const { translate: translateBlog } = useTypedTranslation<BlogEnum>('blog');

  return (
    <Col className={`brands_latest_articles tw-mt-[60px] tw-bg-customGray tw-py-[60px]`}>
      <Container>
        <div className="">
          <h2 className={`tw-mb-[15px] tw-text-[24px] tw-font-semibold`}>
            {translateBlog(BlogEnum.latest_articles)}
          </h2>
          <div
            className={`tw-mb-[40px] tw-h-[5px] tw-max-w-[100px] tw-rounded-[20px] tw-bg-custom-gold`}
          ></div>
          <RelatedBlogs blogtitle={''}></RelatedBlogs>
          <PrimaryButtonLink
            href={'/news'}
            className="tw-mx-auto tw-mt-[25px] tw-flex tw-w-fit tw-justify-center tw-px-[60px] tw-font-bold"
            outlined={true}
          >
            {translateBlog(BlogEnum.all_articles)}
          </PrimaryButtonLink>
        </div>
      </Container>
    </Col>
  );
};
